window.addEventListener(
  'DOMContentLoaded',
  () => {
    const favoriteBtns = $('.c-button.-border-orange.-heart-icon');
    // issue_4141の施策の結果次第で修正
    // 横幅が狭いボタンの場合テキストが入らないため文字をカスタマイズ
    const isShortText = favoriteBtns
      .map(function () {
        return $(this).attr('data-is-square') === 'true';
      })
      .get()
      .some(Boolean);

    const favOn = {
      class: 'c-button -border-orange -heart-icon -sp-text-sm',
      'data-method': 'post',
      innerHTML: isShortText ? 'お気に入り' : 'お気に入り登録',
      href: '/mypage/favorites?job_id=',
    };
    const favOff = {
      class: 'c-button -border-orange -heart-icon -sp-text-sm -solid -done',
      'data-method': 'delete',
      innerHTML: isShortText ? 'お気に入り' : 'お気に入り登録済',
      href: '/mypage/favorites/',
    };
    function toggle(favBtn) {
      if (favBtn.className.includes(favOff.class)) {
        // お気に入り登録済みのクラスを削除
        favBtn.classList.remove('-solid', '-done');
        updateFavBtn(favBtn, favOn);
        updateFavoriteBadge(false);
      } else if (favBtn.className.includes(favOn.class)) {
        // お気に入り登録済みのクラスを追加
        favBtn.classList.add('-solid', '-done');
        updateFavBtn(favBtn, favOff);
        updateFavoriteBadge(true);
      }
    }

    function updateFavBtn(favBtn, favState) {
      favBtn.innerHTML = favState.innerHTML;
      favBtn.href = favState.href + favBtn.id;
      favBtn.setAttribute('data-method', favState['data-method']);
    }

    /**
     * お気に入りのバッジの更新処理
     *
     * @param {boolean} isAdd        - いいねの加算か減算かのフラグ
     */
    function updateFavoriteBadge(isAdd) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('ver') && urlParams.get('ver') === 'issue_4612') {
        const $badge = $('.badge.js-favorite-badge');
        const $icon = $('.js-favorite-icon');
        // 現在のバッジ数を取得（バッジがない場合は 0 とする）
        const currentCount = $badge.length ? Number($badge.text()) : 0;
        // 加算か減算かで新しいカウントを求める
        const newCount = isAdd ? currentCount + 1 : currentCount - 1;
        if (isAdd) {
          // 「いいね」を増やす
          addFavorite($icon, $badge, currentCount, newCount);
        } else {
          // 「いいね」を減らす
          removeFavorite($icon, $badge, newCount);
        }
      }
    }

    /**
     * 「いいね」を増やす処理
     *
     * @param {jQuery} $icon        - いいねアイコンのjQueryオブジェクト
     * @param {jQuery} $badge       - いいね数を表示するバッジのjQueryオブジェクト
     * @param {number} currentCount - 現在のバッジ数
     * @param {number} newCount     - 増やした後のバッジ数
     */
    function addFavorite($icon, $badge, currentCount, newCount) {
      if (currentCount === 0) {
        // バッジが存在しないので、新規作成
        $icon.attr('src', $icon[0].dataset.heartSolidPath);
        const $newBadge = $('<span>')
          .addClass('badge js-favorite-badge')
          .text(newCount);
        $icon.after($newBadge);
      } else {
        // すでにバッジがあるのでテキストを更新
        $badge.text(newCount);
      }
    }

    /**
     * 「いいね」を減らす処理
     *
     * @param {jQuery} $icon    - いいねアイコンのjQueryオブジェクト
     * @param {jQuery} $badge   - いいね数を表示するバッジのjQueryオブジェクト
     * @param {number} newCount - 減らした後のバッジ数
     */
    function removeFavorite($icon, $badge, newCount) {
      if (newCount > 0) {
        // まだ 0 以上なのでテキスト更新
        $badge.text(newCount);
      } else {
        // 0 以下になったのでバッジを削除し、アイコンをアウトラインに戻す
        $badge.remove();
        $icon.attr('src', $icon[0].dataset.heartOutlinePath);
      }
    }

    $.each(favoriteBtns, function (i, theBtn) {
      $(this).on('ajax:success', () => {
        $.each(favoriteBtns, (j, btn) => {
          if (btn.id === theBtn.id) {
            toggle(btn);
          }
        });
      });
    });
  },
  false
);
